import { req } from './axiosFun';




//查询平台配置信息
export const qryPlatform = (params) => { return req("post", "/huichen-ui/sys/qryPlatform", params) };

//编辑数据库备份
export const upSqlBackupRule = (params) => { return req("post", "/huichen-ui/platform/upSqlBackupRule", params) };

//编辑程序配置
export const upProgramRule = (params) => { return req("post", "/huichen-ui/sys/upProgramRule", params) };



// WEBPACK FOOTER //
// ./src/api/platformApi.js